<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui icon iconfont" @click="returnRank"></i>
      <p class="time">{{begin_time}}-{{end_time}}</p>
      <i class="icon iconfont icon-rili time-picker" @click="showTimePicker"></i>

      <div class="sale-detail">

        <img :src="getSrc()" alt="" class="sale-avatar">

        <div class="sale-info">
          <p class="sale-name">{{saleInfo.user.name}}</p>
          <p class="sale-area">{{saleInfo.user.region_name}}</p>
        </div>

        <div class="item-wrapper">
          <div class="item">
            <p class="item-value"> <span class="symbol">¥</span>{{saleInfo.money}}<span class="unit">(万)</span></p>
            <p class="item-name">已签约 {{saleInfo.count}}个</p>
          </div>

          <div class="item">
            <p class="item-value"> <span class="symbol">¥</span>{{saleInfo.no_back_money}}<span class="unit">(万)</span></p>
            <p class="item-name">当前预计回款</p>
          </div>

        </div>

        <div class="item-wrapper">

          <div class="item">
            <p class="item-value"> <span class="symbol">¥</span>{{saleInfo.back_money}}<span class="unit">(万)</span></p>
            <p class="item-name">已回款</p>
          </div>

          <div class="item">
            <p class="item-value">{{alertData.alert_num}}</p>
            <p class="item-name">回款预警项目数</p>
          </div>

        </div>


      </div>




      <div class="menu-tab">


        <div class="caseright" :class="{'active':isActive == 2 }"  @click="changeTab(2)">
          <p>项目回款</p>
          <span class="triangle" v-if=" isActive == 2 "></span>
        </div>
        <!-- <span class="line"></span>   -->

        <div class="caseright" :class="{'active':isActive == 1 }"  @click="changeTab(1)">
          <p>项目汇总</p>
          <span class="triangle" v-if=" isActive == 1 "></span>
        </div>

        <div class="caseleft" :class="{'active':isActive == 0 }" @click="changeTab(0)">
          <p>预警项目</p>
          <span class="triangle" v-if=" isActive == 0 "></span>
        </div>



      </div>


    </div>



    <div class="list-wrapper" >

      <!-- 预警项目 -->
      <div class="list-item" v-for=" item in alertData.data" v-if=" isActive == 0 " @click="goDetail(item)">

        <div class="row text" style="position: relative;">
          <!--<span><span class="title">逾期时间</span>{{Number(item.seconds).toFixed(0)}}天</span>-->
          <span><span style="display:inline-block;white-space:break-word;width:6rem;">{{item.p_name}}</span><span style="position: absolute;right:0.8rem">逾期时间</span></span>
        </div>

        <!--<div class="row text">-->
          <!--<span><span class="title">最后开票时间</span >{{item.last_billed || '未开票' }}</span>-->
          <!--<span>{{status[item.status]}}</span>-->
        <!--</div>-->
        <div class="row text" style='position: relative'>
          <span>{{item.group_name}}</span>
          <span style="position: absolute;left:2.2rem">{{item.sales}}</span>
          <span style="position: absolute;right:1.0rem">{{Number(item.seconds).toFixed(0)}}天</span>
        </div>

        <!--<div class="row text">-->
          <!--<span>{{item.group_name}}</span>-->
        <!--</div>-->

        <!--<div class="row">-->

          <!--<div class="row-item">-->
            <!--<p class="item-value"> <span class="symbol">¥</span>{{ (item.b_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>-->
            <!--<p class="item-name">已回款金额</p>-->
          <!--</div>-->

          <!--<div class="row-item center">-->
            <!--<p class="item-value"> <span class="symbol">¥</span>{{ (item.p_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>-->
            <!--<p class="item-name">项目金额</p>-->
          <!--</div>-->

          <!--<div class="row-item">-->
            <!--<p class="item-value"> <span class="symbol">¥</span>{{ (item.y_no_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>-->
            <!--<p class="item-name">已开发票待回款</p>-->
          <!--</div>-->



        <!--</div>-->
      </div>
      <nodata v-if="isActive == 0 && !alertData.data.length"></nodata>

      <!-- 项目汇总 -->
      <div class="list-item" v-for=" item in orderList" v-if=" isActive == 1 ">

        <div class="row text">
          <span>{{item.reviewed_at.slice(0,10)}}</span>
          <span>{{item.g_name}}</span>
        </div>

        <div class="row text">
          <span>{{item.first_party}}</span>
          <span>{{status[item.status]}}</span>
        </div>

        <div class="row text">
          <span>{{item.project_name}}</span>
          <!-- <span>制作中</span> -->
        </div>

        <div class="row">

          <div class="row-item">
            <p class="item-value"> <span class="symbol">¥</span>{{ (item.back_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
            <p class="item-name">已回款金额</p>
          </div>

          <div class="row-item center">
            <p class="item-value"> <span class="symbol">¥</span>{{ (item.money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
            <p class="item-name">项目金额</p>
          </div>

          <div class="row-item">
            <p class="item-value charge">{{ item.owner }}</p>
            <p class="item-name">负责人</p>
          </div>



        </div>
      </div>
      <nodata v-if="isActive == 1 && !orderList.length"></nodata>

      <!-- 回款项目 -->
      <div class="list-item" v-for=" item in backList" v-if=" isActive == 2 ">

        <div class="row text">
          <span><span class="title">回款周期</span>第{{ Number(item.period)}}期</span>
          <span>{{item.g_name}}</span>
        </div>

        <div class="row text">
          <span><span class="title">实际回款时间</span>{{ item.updated_at.slice(0,10) }}</span>
          <span>制作中</span>
        </div>

        <div class="row text">
          <span>{{ item.project_name }}</span>
          <span><span class="title">负责人</span>{{ item.owner }}</span>
        </div>

        <div class="row">

          <div class="row-item">
            <p class="item-value"> <span class="symbol">¥</span>{{ (item.now_back/10000).toFixed(2) }}<span class="unit">(万)</span></p>
            <p class="item-name">已回款金额</p>
          </div>

          <div class="row-item center">
            <p class="item-value"> <span class="symbol">¥</span>{{ (item.back_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
            <p class="item-name">累积已回款</p>
          </div>

          <div class="row-item">
            <p class="item-value"> <span class="symbol">¥</span>{{(item.money/10000).toFixed(2)  }}<span class="unit">(万)</span></p>
            <p class="item-name">项目金额</p>
          </div>

        </div>


      </div>
      <nodata v-if="isActive == 2 && !backList.length"></nodata>

    </div>


    <!-- 时间选择 -->
    <mt-popup v-model="timePopupVisible" position="bottom"  popup-transition="popup-fade" style="width:100%">
      <mt-picker :slots="slots" @change="onDateChange" valueKey="name"></mt-picker>
      <div class="footer">
        <span @click="timePopupVisible = false">取消</span>
        <span style="color:#5482D2;" @click="timeConfirm">确认</span>
      </div>
    </mt-popup>

  </div>
</template>

<script>
import '../assets/css/drillStyle.css'
import nodata from './public/nodata'
import slotsList from '../assets/js/slotsList'
import { Popup, Picker } from 'mint-ui'
import Vue from 'vue'
import dateChange from '../mixins/dateChange.js'
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)


export default {
  mixins: [dateChange],
  components: {
    nodata,
  },
  data() {
    return {
      type: null,
      saleInfo: { user: {} },
      data: [],

      id: null,
      begin_time: null,
      end_time: null,
      slots: null, //日期选择
      timePopupVisible: false, //时间选择显示
      alertData: { data: [] },
      orderList: null,
      originType: null,

      isActive: 2,// 0:预警项目 1:项目汇总 2:项目回款

      status: {
        0: '待处理',
        1: '开发中',
        2: '已交付',
        3: '已暂停',
        4: '已关闭',
        5: '已完结',
      }, //状态
      alert_info: {
        1: '制作周期超过45天',
        2: '到达回款计划时间未回款',
        3: '已开票未回款累计时间超过30天',
        4: '订单审核通过后合同超过30天未录入',
      },

      backList: [], //销售个人回款

      num: null, //随机数
    }
  },
  methods: {
    showTimePicker() {
      this.timePopupVisible = true
      // this.slots.push()
    },
    goDetail(data) {
      this.$router.push({ name: 'warning', params: { data: data } })
      // console.log(data)
    },
    timeConfirm() {
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      let data = {
        id: this.id,
        begin_time: this.begin_time,
        end_time: this.end_time
      }
      this.getData(data)
      this.timePopupVisible = false
    }, //确定时间


    changeTab(type) { //切换tab
      this.isActive = type
    },

    returnRank() {
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time
      }
      if (this.originType == 2) {
        this.$router.push({ name: 'sales' })
      } else if (this.originType == 3) {
        // window.localStorage.setItem( 'drillData', JSON.stringify(data) )
        this.$router.push({ name: 'homepage' })
      } else {
        // window.localStorage.setItem( 'drillData', JSON.stringify(data) )
        this.$router.push({ name: 'Ranking',query:{begin_time:this.begin_time,end_time:this.end_time} })

      }
    },

    getSrc() {
      let src = ''
      if (this.saleInfo.user.avatar_path == null || this.saleInfo.user.avatar_path == '') {
        // src = require('../assets/img/logo.png')

        src = require(`../assets/img/sale_avatar${this.num}.png`)
      } else {
        src = this.saleInfo.user.avatar_path
      }
      return src
    },

    getData(data) {
      this.$notice.loading()

      this.$http.getSalesDetail(data).then(res => { //销售信息
        this.saleInfo = res.data
      })

      this.$http.getSaleAlertList(data).then(res => { //预警项目
        this.alertData = res.data
        //console.log( res.data)
      })

      this.$http.getSaleOrderList(data).then(res => { //项目汇总
        this.orderList = res.data
        this.$notice.loading(false)
      })

      this.$http.getSaleBackList(data).then(res => {
        this.backList = res.data
      })

    }

  },
  created() {
    this.num = Math.floor(Math.random() * 3 + 1)
    let data = JSON.parse(window.localStorage.getItem('drillData'))
    this.id = data.id
    this.begin_time = data.begin_time
    this.end_time = data.end_time
    this.originType = data.type

    this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
    this.getData(data)
  },
}
</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background-color: #fafafa;
}
.header {
  width: 100%;
  font-size: 0.375rem;
  height: 6.3125rem;
  position: relative;
  margin-bottom: 0.3125rem;
  background-image: url("/static/img/topimg2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /*background-position: top;*/
}

.line {
  border-left: 1px solid rgba(240, 240, 240, 0.5);
  position: absolute;
  bottom: 2%;
  left: 50%;
  height: 0.71875rem;
  right: 0;
  width: 0;
}
.icon.icon-fanhui {
  color: #86898e;
  position: absolute;
  top: 3%;
  left: 2%;
  z-index: 2;
  color: #fff;
}
.menu-tab {
  display: flex;
  width: 100%;
  padding-top: 5.3125rem;
}
.caseleft,
.caseright {
  flex: 1;
  height: 1rem;
  line-height: 1rem;
  position: relative;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.4375rem;
  color: rgba(255, 255, 255, 0.7);
}
.active {
  color: #fff;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 0.25rem solid transparent;
  border-right: 0.25rem solid transparent;
  border-bottom: 0.1875rem solid #fafafa;
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translate(-50%);
}

.listbox {
  width: 100%;
}
.listbox ul {
  width: 96%;
  margin: auto;
}
.listbox ul li {
  width: 100%;
  position: relative;
  margin-bottom: 0.15625rem;
}
.title {
  color: #333;
  line-height: 0.875rem;
  position: relative;
  font-size: 0.4375rem;
  background: #fff;
}
.title p:first-child {
  padding-left: 0.5rem;
  color: #333333;
  font-size: 0.4375rem;
}
.title span {
  font-size: 0.34375rem;
  color: #949494;
  padding-left: 0.5rem;
}
.title img {
  width: 0.6875rem;
  height: 0.8125rem;
  float: left;
  margin-left: 1%;
}
.rightbox {
  position: absolute;
  width: 35%;
  top: 25%;
  right: 2%;
  text-align: right;
  font-size: 0.5625rem;
  font-family: PingFangSC-Regular;
  color: rgba(84, 130, 210, 1);
}
.rightbox p {
  display: inline-block;
}
.rightbox span {
  padding: 0;
  color: rgba(84, 130, 210, 1);
}

.time {
  color: #fff;
  position: absolute;
  top: 0.15625rem;
  text-align: center;
  width: 100%;
  font-size: 0.4375rem;
  /*font-family:PingFangSC-Medium;*/
}
.time-picker {
  color: #fff;
  position: absolute;
  top: 0.05625rem;
  right: 2%;
  font-size: 0.5625rem;
}

.sale-detail {
  width: 9.15625rem;
  height: 3.46875rem;
  background-color: #fff;
  border-radius: 7px;
  display: flex;
  z-index: 999;
  position: absolute;
  top: 1.84375rem;
  margin: 0 0.4375rem;
}
.sale-avatar {
  position: absolute;
  left: 0.40625rem;
  top: -0.6875rem;
  width: 1.8125rem;
  height: 1.8125rem;
  border: 2px solid #fff;
  border-radius: 50%;
}
.sale-detail div {
  /*flex: 1;*/
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.sale-info {
  width: 2.3875rem;
}
.sale-name {
  color: #333;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sale-area {
  color: #949494;
}
.item-wrapper {
  width: 3.4375rem;
}
.item {
  padding: 0.1875rem 0;
}
.item-name {
  font-size: 0.3125rem;
}
.footer {
  width: 100%;
  height: 1.25rem;
  font-size: 0;
}
.footer span {
  width: 50%;
  height: 1.125rem;
  font-size: 0.5rem;
  line-height: 1.25rem;
  display: inline-block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BackDetail.vue